"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _WhiteListedWithdrawAddressSelectComponent = _interopRequireDefault(require("./WhiteListedWithdrawAddressSelectComponent"));
var _eotcWithdrawActions = require("../../redux/actions/eotcWithdrawActions");
var _reduxForm = require("redux-form");
var _depositWithdrawalSelectors = require("../../redux/selectors/depositWithdrawalSelectors");
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
var _sidePanesConstants = require("../../constants/sidePanesConstants");
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var mapStateToProps = function mapStateToProps(state) {
  var position = state.apexCore.position;
  var withdrawAddresses = (0, _depositWithdrawalSelectors.whiteListedAddressesSelector)(state);
  var positionDetails = (0, _productPositionSelectors.productPositionAssetsSelector)(state).find(function (i) {
    return i.ProductId === position.selectedProductId;
  });
  var options = [{
    value: 'default',
    label: 'Not selected'
  }].concat(_toConsumableArray(withdrawAddresses.map(function (opt) {
    return {
      value: opt.AccountIdentifier,
      label: "".concat(opt.Name, " - ").concat(opt.AccountIdentifier),
      disabled: !opt.Verified
    };
  })));
  return {
    positionDetails: positionDetails,
    isLoading: state.eotcWithdraw.isLoading,
    options: options
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetBankField: function resetBankField(bank) {
      return dispatch((0, _reduxForm.change)('createFiatWithdraw', 'Bank', bank));
    },
    onSelect: function onSelect(bank) {
      return dispatch((0, _eotcWithdrawActions.selectWithdrawBank)(bank));
    },
    fetchAccountWithdrawInfos: function fetchAccountWithdrawInfos() {
      return dispatch((0, _eotcWithdrawActions.fetchAccountWithdrawInfos)());
    },
    openWhitelistSidepane: function openWhitelistSidepane(props) {
      return dispatch((0, _sidePaneActions.openSidePane)(_sidePanesConstants.SIDE_PANES.WHITE_LIST_ADDRESS, _objectSpread(_objectSpread({}, props), {}, {
        hideHeader: true
      })));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WhiteListedWithdrawAddressSelectComponent["default"]);